import React from 'react';
import { ISourceTimelineEventType } from '@24i/player-base';
import { getLiveProgressPercentageBasedOnCurrentTime } from '@24i/player-utils';
import { usePlayerTimes } from '@24i/player-utils-react';
import { Midroll } from './styled';
const PERCENT = 100;
const Midrolls = ({ playerInstance, className = '', style = null, }) => {
    var _a, _b, _c, _d;
    usePlayerTimes(playerInstance);
    const { programStart = 0, programEnd = 0 } = playerInstance.getMetadata();
    const { live, timeshiftRange, seekableRange, timeline, adBreaks, duration } = playerInstance;
    const windowRange = live ? timeshiftRange : seekableRange;
    const { start, end } = windowRange || {};
    const dvrWindowEndDate = (_b = (_a = playerInstance === null || playerInstance === void 0 ? void 0 : playerInstance.getUTCTimestamp(end)) === null || _a === void 0 ? void 0 : _a.getTime()) !== null && _b !== void 0 ? _b : Date.now();
    const advertisements = (_d = (_c = timeline === null || timeline === void 0 ? void 0 : timeline.filter((advertisement) => advertisement.type === ISourceTimelineEventType.ADVERTISEMENT)) !== null && _c !== void 0 ? _c : adBreaks === null || adBreaks === void 0 ? void 0 : adBreaks.map((offset) => ({ start: offset, end: offset }))) !== null && _d !== void 0 ? _d : [];
    const getPercentage = (adPosition) => {
        if (live && !end) {
            return null;
        }
        const unclamped = live
            ? getLiveProgressPercentageBasedOnCurrentTime(programStart, programEnd, start, end, adPosition, undefined, dvrWindowEndDate) * PERCENT
            : (adPosition / duration) * PERCENT;
        return Math.max(0, Math.min(100, unclamped));
    };
    return (React.createElement("div", null, advertisements.map((advertisement) => {
        const startPercent = getPercentage(advertisement.start);
        const endPercent = getPercentage(advertisement.end);
        if (startPercent === null || endPercent === null) {
            return null;
        }
        const length = endPercent - startPercent;
        return (React.createElement(Midroll, { className: `${className} Midroll`, "data-test": "Midroll", key: `Midroll-${advertisement.start}`, fromLeft: startPercent, length: length, style: style }));
    })));
};
export { Midrolls };
//# sourceMappingURL=index.js.map